import React, { Suspense, useRef } from 'react';
// Mounts on first open and stays mounted - unmounting on close cuts off the exit animation.
const MountOnOpen = ({ open, fallback = null, children }) => {
    const opened = useRef(open);
    if (open) {
        opened.current = true;
    }
    if (!opened.current) {
        return null;
    }
    return React.createElement(Suspense, { fallback: fallback }, children);
};
export default MountOnOpen;
